import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FlightsCheckIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M17 16.2487L11.0884 14.408V18.4606L12.5747 19.5757V20.6733L9.99085 19.9477L7.42454 20.6733V19.5757L8.87576 18.4606V14.408L3 16.2487V14.7968L8.87652 11.0971V7.04524C8.87652 6.73807 8.98247 6.47893 9.19436 6.26627C9.29835 6.16162 9.42266 6.07936 9.55964 6.02457C9.69662 5.96977 9.84338 5.94361 9.99085 5.94768C10.1358 5.94456 10.28 5.97082 10.4145 6.02487C10.5491 6.07892 10.6713 6.15965 10.7739 6.2622C10.8764 6.36475 10.9572 6.48699 11.0112 6.62156C11.0653 6.75613 11.0915 6.90025 11.0884 7.04524V11.0978L17 14.7975V16.2487Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11ZM19.4069 5.79061C19.5674 5.5659 19.5153 5.25362 19.2906 5.09313C19.0659 4.93263 18.7536 4.98468 18.5931 5.20939L16.4362 8.22928L15.3536 7.14665C15.1583 6.95139 14.8417 6.95139 14.6464 7.14665C14.4512 7.34191 14.4512 7.6585 14.6464 7.85376L16.1464 9.35376C16.2504 9.45769 16.3948 9.51062 16.5412 9.4985C16.6877 9.48637 16.8214 9.41042 16.9069 9.29081L19.4069 5.79061Z'
                fill='currentColor'
            />
        </>
    ),
})

FlightsCheckIcon.displayName = 'FlightsCheckIcon'
